import logo from './logo.svg';
import './App.css';
import React, {useState} from 'react';
import Welcome from './Welcome.js';
import Search1 from './Search1.js';
import {useQuery, useMutation} from 'react-query';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import NavbarComponent from './components/NavbarComponent';
import {Container} from 'react-bootstrap';
import {Link, BrowserRouter ,  Routes, Route} from 'react-router-dom';
import Cancel from './pages/Cancel'
import NavBar from './NavBar.js'
import Cart from './pages/Cart.js'
import Orders from './pages/Orders'
import Admin from './pages/Admin'
import Store from './pages/Store'
import About from './pages/About'
import AssetShowPage from './pages/AssetShowPage'
import AddApiProduct from './pages/AddApiProduct'
import ListAssets from './pages/ListAssets'
import Pay from './pages/Pay'
import Success from './pages/Success'
import CartProvider from './CartContext.js'
import './styles.css'
function App() {

	const [image, setImage]=useState(false);

	const [firstName, setFirstName]=useState("");
	const [lastName, setLastName]=useState("");

	const [manName, setManName] = useState("");
	const [partNumber, setPartNumber] = useState("");
	const [manPartNumber, setManPartNumber] = useState("");
	const [partOption, setPartOption] = useState("");
	const [partDesc, setPartDesc] = useState("");
	const [partShortDesc, setPartShortDesc] = useState("");
	const [partImgUrl, setPartImgUrl] = useState("");
	const [partTechImgUrl, setPartTechImgUrl] = useState("");
	const [partSalePrice, setPartSalePrice] = useState("");
	const [partManPrice, setPartManPrice] = useState("");
	const [currency, setCurrency] = useState("");
	const [merchantId, setMerchantId] = useState("");
	const [merchantName, setMerchantName] = useState("");
	const [deliveryCharge, setDeliveryCharge] = useState("");
	const [search,setSearch] = useState("");
	const {isLoading, error, data, isFetching, refetch} = useQuery('dogs',
		() => axios ('https://random.dog/woof.json'),
		{
			enabled: false,
		}
		
		);

const Button = () => {
return	  <button onClick={refetch}>Get </button>
}

const PostData = async  (part) => {
	console.log("part");
	console.log(part);
//	let x = {keyword: user.firstName};
	//const response = await axios.post("https://peacioapi.com:3001/addPartAPI", part);
	const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/addPartAPI`, part);

	//	console.log(x);
//	const response = await fetch("https://peacioapi.com:3000/getDBData", {
  //         method: 'POST',
//	   body: x,
//	headers: {
  //         'Content-type': 'application/json; charset-UTF-8'
//	}
//	})
	return response;


}

const searchDBx = async (searchVal) => {
	console.log("searching ...");
	console.log(searchVal);
//	const baseUrl = "https://peacioapi.com:3000/searchDB/"+searchVal; 
//	let res = await axios.get(baseUrl);
//	console.log(res.data);
}

const {mutate,  isError} = useMutation(PostData, {
	onSuccess: (successData) => {
		console.log("post was done");

           console.log(successData);
	}
})
const ImageDisplay = () => {
return ( data ? <img src={data.data.url}/> : <p></p>);
}
 console.log("render");
 console.log(error);
 console.log(data);
	if (error) return <h1>{error.message}</h1>
	if (isLoading) return <h1>Loading</h1>
		//console.log(data);




  return (
    <div >
	  <CartProvider>
         <Container>
		<NavBar />
	    <NavbarComponent>

	    </NavbarComponent>
                <Routes>
                     <Route index element={<Welcome />} />                    
                     <Route path="succcess" element={<Success />} />                    
                     <Route path="cancel" element={<Cancel />} />     
                     <Route path="/asset/:productId" element={<AssetShowPage />} />
                     <Route path="/listassets/" element={<ListAssets />} />
                     <Route path="/invest/" element={<Pay />} />
                     <Route path="/portfolio/" element={<Orders />} />
                     <Route path="/admin/" element={<Admin />} />
                     <Route path="/about/" element={<About />} />
                     <Route path="/investments/" element={<Cart />} />
                     <Route path="/search1/" element={<Search1 />} />
	        </Routes>
          <div>
	  </div>
	  </Container>
</CartProvider>

    </div>
  );
}

export default App;
